<template>
    <v-toolbar :color="'#' + color" class="appNavigationBar" height="40">
        <v-toolbar-items>
            <router-link to="/" tag="a">
                <span>
                    <img src="../../../assets/JLLlogo.png" height="40px" />
                </span>
            </router-link>
            <!--<router-link v-if="$store.getters.isInRoleArr('View_InformaArea/Informa/Index,ADMIN')"
                         to="/Informa"
                         tag="a"
                         :class="{ selected: selectedPath.toLowerCase().includes('/informa'), shadowhover: true }">
                <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_informa')}}</span>
            </router-link>-->
            <router-link v-if="$store.getters.isInRoleArr('View_LegalArea/LegalClient/ClientList,LEGAL,LEGAL_MNG,LEGAL_ADM,LEGAL_ASS,LEGAL_ASSISTANT_WITH_REOPEN,ADMIN')"
                         to="/DueDiligence"
                         tag="a"
                         :class="{ selected: selectedPath.toLowerCase().includes('/duediligence'), shadowhover: true }">
                <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_due_diligence')}}</span>
            </router-link>
            <v-menu v-if="$store.getters.isInRoleArr('ADMIN,R_TETRIS_ESIGN_ADMIN,R_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index,View_ESignArea/ESign/Index,JLLT_VIEW,HR_ADMIN')"
                    dark @input="fnOnESignMenuChange"
                    offset-y
                    transition="slide-y-transition"
                    rounded="10"
                    content-class="elevation-2">
                <template v-slot:activator="{ attrs, on }">
                    <button tag="a"
                            v-bind="attrs"
                            v-on="on"
                            :class="{
                            selected: selectedPath.toLowerCase().includes('/esign'),
                            shadowhover: true,
                            }">
                        <span class="nav-button"> {{$t('components.navigation_bar.title_esign_minus')}} </span>
                        <v-icon color="#ffffff" :class="{ rotate90: esignMenuIsActive, 'animated-icon': true }">mdi-menu-right</v-icon>
                    </button>
                </template>
                <v-list class="menulistitem" v-if="$store.getters.isInRoleArr('ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index,View_TetrisESignArea/TetrisESign/Index,JLLT_VIEW,HR_ADMIN')">

                    <v-list-item v-if="$store.getters.isInRoleArr('ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index')">
                        <router-link to="/ESign"
                                     tag="a"
                                     :class="{
                                       selected: selectedPath.toLowerCase().includes('/esign') && !selectedPath.toLowerCase().includes('/esigntetris')  && !selectedPath.toLowerCase().includes('/esigndashboard')  && !selectedPath.toLowerCase().includes('/esignjllt')  && !selectedPath.toLowerCase().includes('/esignhr'),
                                       shadowhover: true,
                                     }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_esign_JLL')}}</span>
                        </router-link>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index')">
                        <router-link to="/ESignTetris"
                                     tag="a"
                                     :class="{
                                       selected: selectedPath.toLowerCase().includes('/esigntetris'),
                                       shadowhover: true,
                                     }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_esign_TETRIS')}}</span>
                        </router-link>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('JLLT_VIEW')">
                        <router-link to="/ESignJLLT"
                                     tag="a"
                                     :class="{
                                       selected: selectedPath.toLowerCase().includes('/esignjllt'),
                                       shadowhover: true,
                                     }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_esign_JLLT')}}</span>
                        </router-link>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('ADMIN, HR_ADMIN')">
                        <router-link to="/ESignHR"
                                     tag="a"
                                     :class="{
                                       selected: selectedPath.toLowerCase().includes('/esignhr'),
                                       shadowhover: true,
                                     }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_esign_HR')}}</span>
                        </router-link>
                    </v-list-item>
                    <hr v-if="$store.getters.isInRoleArr('DASHBOARD_OVERVIEW,DASHBOARD_JLL,DASHBOARD_TETRIS')" />
                    <v-list-item v-if="$store.getters.isInRoleArr('DASHBOARD_OVERVIEW,DASHBOARD_JLL,DASHBOARD_TETRIS')">
                        <router-link to="/ESignDashboard"
                                     tag="a"
                                     :class="{
                                       selected: selectedPath.toLowerCase().includes('/esigndashboard'),
                                       shadowhover: true,
                                     }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_esign_dashboard')}}</span>
                        </router-link>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-menu dark v-if="$store.getters.isInRoleArr('View_AdminArea/Users/MngUsers,View_AdminArea/Users/MngProfiles,View_AdminArea/Users/MngRoles,DEV_MODE,ADMIN,R_ESIGN_ADMIN,R_ESIGN_TETRIS_ADMIN')"
                    @input="fnOnAdminMenuChange"
                    offset-y
                    transition="slide-y-transition"
                    rounded="10"
                    content-class="elevation-2">
                <template v-slot:activator="{ attrs, on }">
                    <button tag="a"
                            v-bind="attrs"
                            v-on="on"
                            :class="{
                            selected: selectedPath.toLowerCase().includes('/admin'),
                            shadowhover: true,
                            }">
                        <span class="nav-button"> Admin </span>
                        <v-icon color="#ffffff" :class="{ rotate90: adminMenuIsActive, 'animated-icon': true }">mdi-menu-right</v-icon>
                    </button>
                </template>
                <v-list class="menulistitem">
                    <v-list-item v-if="$store.getters.isInRoleArr('ADMIN')">
                        <button @click="fnRefreshCache" class="shadowhover">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_refresh_cache')}}</span>
                        </button>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('View_AdminArea/Users/MngUsers,ADMIN,R_ESIGN_ADMIN')">
                        <router-link to="/Admin/Users"
                                     tag="a"
                                     :class="{
                                    selected: selectedPath.toLowerCase().includes('/admin/users'),
                                    shadowhover: true,
                                    }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_users')}}</span>
                        </router-link>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('View_AdminArea/Users/MngProfiles,ADMIN')">
                        <router-link to="/Admin/Profiles"
                                     tag="a"
                                     :class="{
                selected: selectedPath.toLowerCase().includes('/admin/profiles'),
                shadowhover: true,
              }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_profiles')}}</span>
                        </router-link>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('View_AdminArea/Users/MngRoles,ADMIN')">
                        <router-link to="/Admin/Roles"
                                     tag="a"
                                     :class="{
                selected: selectedPath.toLowerCase().includes('/admin/roles'),
                shadowhover: true,
              }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_roles')}}</span>
                        </router-link>
                    </v-list-item>
                    <hr v-if="$store.getters.isInRole('DEV_MODE')" />
                    <v-list-item v-if="$store.getters.isInRoleArr('R_ESIGN_ADMIN,R_TETRIS_ESIGN_ADMIN,ADMIN')">
                        <router-link to="/Admin/Approvers"
                                     tag="a"
                                     :class="{
                selected: selectedPath.toLowerCase().includes('/admin/approvers'),
                shadowhover: true,
              }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_approvers')}}</span>
                        </router-link>
                    </v-list-item>
                    <hr v-if="$store.getters.isInRole('R_ESIGN_ADMIN,R_TETRIS_ESIGN_ADMIN,ADMIN')" />
                    <v-list-item v-if="$store.getters.isInRole('DEV_MODE')">
                        <v-menu dark @input="fnOnDevMenuChange"
                                offset-x
                                transition="slide-x-transition"
                                rounded="10"
                                content-class="elevation-2"
                                open-on-hover
                                slide-x>
                            <template v-slot:activator="{ attrs, on }">
                                <button tag="button"
                                        v-bind="attrs"
                                        v-on="on"
                                        class="shadowhover">
                                    <span class="nav-button"> CHANGE INSTANCE </span>
                                    <v-icon :class="{
                      translate3: devMenuIsActive,
                      'animated-icon': true,
                    }">mdi-menu-right</v-icon>
                                </button>
                            </template>
                            <v-list class="menulistitem">
                                <v-list-item>
                                    <button @click="fnSetInstance('es')"
                                            :class="{ selected: $store.getters.instance == 'es' , langButton: true ,shadowhover: true}">
                                        <span class="nav-button flag">
                                            <country-flag country='es' size='small' rounded /> &nbsp;
                                            Spain
                                        </span>
                                    </button>
                                </v-list-item>
                                <!--<v-list-item>
                                    <button @click="fnSetInstance('uk')"
                                            :class="{ selected: $store.getters.instance == 'uk' }">
                                        <span class="nav-button flag shadowhover">
                                            <country-flag country='gb' size='small' rounded /> &nbsp;
                                            England
                                        </span>
                                    </button>
                                </v-list-item>-->
                                <v-list-item>
                                    <button @click="fnSetInstance('pt')"
                                            :class="{ selected: $store.getters.instance == 'pt' , langButton: true, shadowhover: true}">
                                        <span class="nav-button flag ">
                                            <country-flag country='pt' size='small' rounded /> &nbsp;
                                            Portugal
                                        </span>
                                    </button>
                                </v-list-item>
                                <v-list-item>
                                    <button @click="fnSetInstance('it')"
                                            :class="{ selected: $store.getters.instance == 'it', langButton: true , shadowhover: true}">
                                        <span class="nav-button flag ">
                                            <country-flag country='it' size='small' rounded /> &nbsp;
                                            Italy
                                        </span>
                                    </button>
                                </v-list-item>
                                <!--<v-list-item>
                                    <button @click="fnSetInstance('fr')"
                                            :class="{ selected: $store.getters.instance == 'fr' }">
                                        <span class="nav-button flag shadowhover">
                                            <country-flag country='fr' size='small' rounded /> &nbsp;
                                            France
                                        </span>
                                    </button>
                                </v-list-item>-->
                                <!--<v-list-item>
                                    <button @click="fnSetInstance('ch')"
                                            :class="{ selected: $store.getters.instance == 'ch' }">
                                        <span class="nav-button flag shadowhover">
                                            <country-flag country='cn' size='small' rounded /> &nbsp;
                                            China
                                        </span>
                                    </button>
                                </v-list-item>-->
                                <!--<v-list-item>
                                    <button @click="fnSetInstance('us')"
                                            :class="{ selected: $store.getters.instance == 'us' }">
                                        <span class="nav-button flag shadowhover">
                                            <country-flag country='us' size='small' rounded /> &nbsp;
                                            USA
                                        </span>
                                    </button>
                                </v-list-item>-->
                            </v-list>
                        </v-menu>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('ADMIN')">
                        <router-link to="/admin/AuthMappings"
                                     tag="a"
                                     :class="{
                selected: selectedPath.toLowerCase().includes('/authmappings'),
                shadowhover: true,
              }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_authmappings')}}</span>
                        </router-link>
                    </v-list-item>
                    <v-list-item v-if="$store.getters.isInRoleArr('ADMIN')">
                        <router-link to="/HealthCheck"
                                     tag="a"
                                     :class="{
                selected: selectedPath.toLowerCase().includes('/healthcheck'),
                shadowhover: true,
              }">
                            <span class="nav-button" color="#ffffff"> {{$t('components.navigation_bar.title_healthchecks')}}</span>
                        </router-link>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar-items>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
            <div class="flag">
                <country-flag :country="countryFlagByInstance" size='small' rounded />
            </div>
            <v-menu dark @input="fnOnLogoMenuChange"
                    offset-y
                    offset-x
                    transition="slide-y-transition"
                    rounded="10"
                    content-class="elevation-2">
                <template v-slot:activator="{ attrs, on }">
                    <button tag="button" class="shadowhover" v-bind="attrs" v-on="on">
                        <span class="nav-button">
                            <img src="../../../assets/JLLlogo.png" height="40px" />
                        </span>
                        <v-icon color="#ffffff" :class="{ rotate90: logoMenuIsActive, 'animated-icon': true }">mdi-menu-right</v-icon>
                    </button>
                </template>
                <v-list class="menulistitem">
                    <v-list-item>
                        <button @click="fnLogout">
                            <span class="nav-button inline-flex">
                                <span> {{ userName }} &nbsp; &nbsp; &nbsp;</span>
                                <span>
                                    <v-icon color="#d68585" class="shadowhover logoutbutton">mdi-logout</v-icon>
                                </span>
                            </span>
                        </button>
                    </v-list-item>
                    <v-list-item>
                        <button>
                            <span class="mailtext"> &nbsp; &nbsp; ({{ userEmail }}) &nbsp; &nbsp; </span>
                        </button>
                    </v-list-item>
                    <hr />
                    <v-list-item>
                        <router-link to="/About"
                                     tag="a"
                                     :class="{
                selected: selectedPath.toLowerCase().includes('/about'),
                shadowhover: true,
              }">
                            <span class="nav-button" color="#ffffff"> About</span>
                        </router-link>
                    </v-list-item>
                    <v-list-item>
                        <v-menu dark @input="fnOnLangMenuChange"
                                offset-x
                                :left="true"
                                rounded="10"
                                content-class="elevation-2"
                                open-on-hover
                                slide-x>
                            <template v-slot:activator="{ attrs, on }">
                                <button tag="button"
                                        v-bind="attrs"
                                        v-on="on"
                                        class="shadowhover">
                                    <span class="nav-button"> Language </span>
                                    <v-icon :class="{
                      rotate180: langMenuIsActive,
                      'animated-icon': true,
                    }">mdi-menu-right</v-icon>
                                </button>
                            </template>
                            <v-list class="menulistitem">
                                <v-list-item>
                                    <button @click="fnSetLanguage('en')"
                                            :class="{ selected: $store.getters.langCode == 'en', langButton: true , shadowhover: true}">
                                        <span class="nav-button flag">
                                            <country-flag country='gb' size='small' rounded />  &nbsp;
                                            English
                                        </span>
                                    </button>
                                </v-list-item>
                                <v-list-item>
                                    <button @click="fnSetLanguage('es')"
                                            :class="{ selected: $store.getters.langCode == 'es', langButton: true, shadowhover: true}">
                                        <span class="nav-button flag">
                                            <country-flag country='es' size='small' rounded />  &nbsp;
                                            Spanish
                                        </span>
                                    </button>
                                </v-list-item>

                                <v-list-item>
                                    <button @click="fnSetLanguage('it')"
                                            :class="{ selected: $store.getters.langCode == 'it', langButton: true, shadowhover: true }">
                                        <span class="nav-button flag">
                                            <country-flag country='it' size='small' rounded />  &nbsp;
                                            Italian
                                        </span>
                                    </button>
                                </v-list-item>
                                <v-list-item>
                                    <button @click="fnSetLanguage('pt')"
                                            :class="{ selected: $store.getters.langCode == 'pt', langButton: true , shadowhover: true}">
                                        <span class="nav-button flag">
                                            <country-flag country='pt' size='small' rounded />  &nbsp;
                                            Portuguese
                                        </span>
                                    </button>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item>
                    <v-list-item v-if="documentationConfig != undefined">
                        <v-menu dark @input="fnOnDocuMenuChange"
                                offset-x
                                :left="true"
                                rounded="10"
                                content-class="elevation-2"
                                open-on-hover
                                slide-x>
                            <template v-slot:activator="{ attrs, on }">
                                <button tag="button"
                                        v-bind="attrs"
                                        v-on="on"
                                        class="shadowhover">
                                    <span class="nav-button"> Documentation </span>
                                    <v-icon :class="{
                                      rotate180: DocuMenuIsActive,
                                      'animated-icon': true,
                                    }">
                                        mdi-menu-right
                                    </v-icon>
                                </button>
                            </template>
                            <v-list class="menulistitem" v-if="documentationConfig != undefined">
                                <v-list-item v-for="(item, idx) in documentationConfig" :key="idx">
                                    <button v-if="!item.external" @click="fnDownloadESignDocumentation(item)">
                                        <span class="nav-button shadowhover">
                                           {{ $t(item.title) }}
                                        </span>
                                    </button>
                                    <a v-if="item.external" :href="item.url" target="_blank">
                                        <span class="nav-button shadowhover">
                                           {{ $t(item.title) }}
                                        </span>
                                    </a>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar-items>
    </v-toolbar>
</template>

<script>
    import CountryFlag from 'vue-country-flag';
    import appService from '@/shared/services/apiServices/appService';
    import documentationService from '@/shared/services/documentation.service.js';
    import userService from '@/admin/services/api/user.api.service'
    import LazUtils from '@/shared/utils/LazUtils';
    export default {
        name: "NavigationMenu",
        components: { CountryFlag },
        data() {
            return {
                AdminMenuIsActive: false,
                ESignMenuIsActive: false,
                DevMenuIsActive: false,
                LogoMenuIsActive: false,
                LangMenuIsActive: false,
                DocuMenuIsActive: false,
                countryFlags: [
                    { uk: 'gb' },
                    { ch: 'cn' },
                ],
            };
        },
        props: {
            items: [],
            color: String,
        },
        methods: {
            fnOnDevMenuChange(ev) {
                this.DevMenuIsActive = ev;
            },
            fnOnAdminMenuChange(ev) {
                this.AdminMenuIsActive = ev;
            },
            fnOnESignMenuChange(ev) {
                this.ESignMenuIsActive = ev;
            },
            fnOnLogoMenuChange(ev) {
                this.LogoMenuIsActive = ev;
            },
            fnOnLangMenuChange(ev) {
                this.LangMenuIsActive = ev;
            },
            fnOnDocuMenuChange(ev) {
                this.DocuMenuIsActive = ev;
            },
            async fnSetInstance(item) {
                let data = { userMail: this.userEmail, newInstance: item }
                let response = await appService.Post("login", "changeUserInstance", JSON.stringify(data))
                if (response.result) {
                    this.$toasted.show(this.$t('common.lbl_success'), { type: 'success' });
                } else {
                    this.$toasted.show(this.$t('common.lbl_error'), { type: 'error' });
                }
                this.$store.dispatch("Logout");
            },
            fnSetLanguage(item) {
                this.$root.$i18n.locale = item
                this.$store.dispatch("SetLangCode", item);
            },
            fnDownloadESignDocumentation(item) {
                let url = 'api/Asset/DownloadESignManual'

                this.$store.dispatch("insertWidgetCard", {
                    component: "ExportationModal",
                    properties: {
                        dynamicId: LazUtils.newGuid(),
                        keyId: LazUtils.newGuid(),
                        instance: item.instance,
                        exportData: item,
                        url: url,
                        downloadingText: this.$t("common.downloadingfile"),
                        errorText: this.$t("common.errorgeneratingfile"),
                        readyText: this.$t("common.downloadingfile")
                    }
                });
            },
            fnLogout: function () {
                this.$store.dispatch('Logout');
            },
            async fnRefreshCache() {
                let response = false;
                response = await userService.clearUserCache(null, this.$refs.divLoading);
                if (response.result) {
                    this.$toasted.show(this.$t('common.lbl_success'), { type: 'success' });
                    this.$store.dispatch("OnUsersCacheRefresh", { key: Date.now() });
                } else {
                    this.$toasted.show(this.$t('common.lbl_error'), { type: 'error' });
                }

            },
        },
        computed: {
            userName() {
                return this.$store.getters.UserFullName;
            },
            userEmail() {
                return this.$store.getters.UserName;
            },
            instances() {
                return this.$store.getters.instances;
            },
            languages() {
                return this.$store.getters.languages;
            },
            selectedInstance() {
                return this.$store.getters.instance;
            },
            selectedLanguage() {
                return this.$store.getters.langCode;
            },
            selectedPath() {
                return this.$route.path;
            },
            adminMenuIsActive() {
                return this.AdminMenuIsActive;
            },
            esignMenuIsActive() {
                return this.ESignMenuIsActive;
            },
            devMenuIsActive() {
                return this.DevMenuIsActive;
            },
            logoMenuIsActive() {
                return this.LogoMenuIsActive;
            },
            langMenuIsActive() {
                return this.LangMenuIsActive;
            },
            countryFlagByInstance() {
                let val = this.countryFlags.filter(x => x[this.selectedInstance] != undefined)
                return val.length != 0 ? val[0][this.selectedInstance] : this.selectedInstance
            },
            documentationConfig() {
                var config = documentationService.getDocumentationConfig(this.documentationSelect).filter(x => x !== undefined)
                return config.length ? config : undefined;
            },
            documentationSelect() {
                let result = [];
                if (this.selectedInstance) {
                    result.push('INSTANCE_' + this.selectedInstance.toUpperCase())
                }
                if (this.$store.getters.isInRole("JLLT_VIEW")) {
                    result.push('GLOBAL_JLLT')
                }
                return result;
            }
        },
    };
</script>

<style scoped>
    .nav-button {
        padding: 0px 10px 0px 10px;
        font-weight: 500;
        font-size: 16px;
        width: 100%;
        color: white
    }

    .appNavigationBar {
        opacity: 1
    }

    .shadowhover:hover {
        background-color: #333333;
    }

    button.selected span {
        font-family: "iris-bold"
    }

    button span {
        font-family: "iris-medium"
    }

    button.selected:hover {
        background-color: #333333;
    }

    .toolbutton {
        margin: 0px 0px 0px 20px;
    }

    button {
        transition: 0.2s;
    }

    .menulistitem hr {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .menulistitem div {
        margin: 0px;
        padding: 0px;
        min-height: 0px;
        width: 100%;
    }

        .menulistitem div button {
            min-width: 130px;
            width: 100%;
            height: 100%;
            text-align: left;
            display: flex;
            justify-content: center;
            justify-items: center;
            align-content: center;
            align-items: center;
        }

    .animated-icon {
        transition: 500ms;
        right: 5px;
        position: relative;
    }

        .animated-icon.rotate90 {
            transform: rotate(0.25turn);
        }

        .animated-icon.rotate180 {
            transform: rotateY(-0.5turn);
        }

        .animated-icon.translate3 {
            transform: translate(3px);
        }

    .flag {
        align-items: center;
        display: flex;
        padding: 0px 20px 0px 10px;
    }

    .logoutbutton {
        position: absolute !important;
        right: 0px;
        padding: 0px 3px 0px 3px;
        margin: 0px 3px 0px 3px;
        border-radius: 5px;
    }




    a.selected span {
        font-family: "iris-bold"
    }

    a span {
        font-family: "iris-medium"
    }

    a.selected:hover {
        background-color: #333333;
    }

    a:hover {
        transition: 0.2s;
        text-decoration: none;
    }



    .menulistitem div a {
        min-width: 130px;
        width: 100%;
        height: 100%;
        text-align: left;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }

    .navigation-menu div div a {
        display: flex;
        align-items: center;
    }

    .menulistitem div a {
        min-height: 24px
    }

    .menulistitem div button {
        min-height: 24px
    }

    .langButton {
        max-height: 24px;
        padding: 0px !important;
        margin: 0px !important;
    }

    .mailtext {
        font-size: 12px;
    }
</style>

